// Construye el nombre de archivo con timestamp DD-MM-YYYY-HHmm.
// `prefix` permite reusar el mismo formato para otros documentos (p. ej.
// "PickingPackingOTS") sin romper a los callers existentes, que siguen
// obteniendo "EtiquetasOTS" por default.
export default function buildFileName(extension, prefix = 'EtiquetasOTS') {
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = currentDate.getFullYear();
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');

    return `${prefix}-${day}-${month}-${year}-${hours}${minutes}.${extension}`
}